import { PureComponent } from 'react'

import { Label } from '../Label'
import { InputGroupLabelStyled } from './styles/InputGroupLabelStyled'

export interface IInputGroupLabelProps {}

export class InputGroupLabel extends PureComponent<IInputGroupLabelProps> {
  render() {
    const { children, ...otherProps } = this.props
    return (
      <InputGroupLabelStyled {...otherProps}>
        <Label>{children}</Label>
      </InputGroupLabelStyled>
    )
  }
}
